/**
 * AppThemeProvider
 *
 * A wrapper component that provides the correct theme based on:
 * - User preference (light/dark/system)
 * - Admin vs Tenant context
 *
 * This component uses the useAppTheme hook and can be used to wrap
 * class components that need theme access.
 */

import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useAppTheme } from '../../../hooks/useAppTheme';

const AppThemeProvider = ({ children }) => {
  const theme = useAppTheme();

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
